import _ from 'lodash'
import { MARKETING_TAGS_CONFIG_INIT } from '../constants/actionTypes'

const initialState = {}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case MARKETING_TAGS_CONFIG_INIT:
      return _.cloneDeep(action.marketingTagsConfig)
    default:
      return state
  }
}

export default reducer
export { initialState }
